// extracted by mini-css-extract-plugin
export default {"switch":"_3FO7XmA6bCtwTmVeNinbFN","slider":"_26tMSCi-PGI4Q0wSSntlly"};